<template>
  <div class="d-flex align-items-center">
    <i
        class="mdi mdi-arrow-left mdi-24px mr-3 cursor-pointer"
        @click="handleClick"
    ></i>
    <h3 class="m-0">
      {{title}}
    </h3>
  </div>
</template>

<script>
export default {
  name: "title-return",

  props : {
    title : String
  },

  methods : {
    handleClick(){
      window.history.back()
    }
  }
}
</script>

<style scoped>

</style>